module.exports = __webpack_public_path__ + "static/2016-Interlab-cde8e78d80736cf8a11c7fc36771c652.pdf";